module.exports = __webpack_public_path__ + "static/media/24.ee061c84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/24.jpg
// module id = 285
// module chunks = 0